
import { mapState, mapActions, mapGetters } from "vuex";
import CardNoItem from "@/components/CardView/CardNoItem.vue";
import BreadcrumbsBar from "@/components/bars/BreadcrumbsBar.vue";
import VideoEmbed from "@/components/Custom/embed";
export default {
  head() {
    let url = "https://startupcambodia.gov.kh/";
    if (process.browser) url = window.location.href;
    const { first_name_kh, first_name, last_name_kh, last_name } =
      this.profileInfo || {};
    const name = this.$isKm()
      ? [first_name_kh, last_name_kh]
      : [first_name, last_name];
    let img = this.profileInfo?.profile;
    let title = name.filter((item) => !!item).join(" ") || "Startup Detail";
    const desc = (this.profileInfo?.bio || "").slice(0, 128);
    return {
      meta: [
        { hid: "og:url", content: url },
        { hid: "og:title", property: "og:title", content: title },
        { hid: "og:type", property: "og:type", content: "article" },
        { hid: "image", name: "image", content: img },
        { hid: "og:image", property: "og:image", content: img },
        { hid: "description", name: "description", content: desc },
        {
          hid: "og:description",
          property: "og:description",
          content: desc,
        },
        {
          hid: "twitter:image",
          property: "twitter:image",
          content: img,
        },
        {
          hid: "twitter:title",
          property: "twitter:title",
          content: title,
        },
        {
          hid: "twitter:description",
          property: "twitter:description",
          content: desc,
        },
        {
          hid: "twitter:card",
          property: "twitter:card",
          content: "summary_large_image",
        },
      ],
    };
  },
  name: "PageMentorDetail",
  layout: "common",
  components: {
    CardNoItem,
    BreadcrumbsBar,
    VideoEmbed,
  },
  data() {
    return {
      notFound: false,
      makingConnection: false,
      profileInfo: {},
      expertises: [],
    };
  },
  computed: {
    ...mapState("user", ["currentUser"]),
    ...mapState("stakeholder", ["isLoading"]),
    breadCrumbs() {
      const crumbs = [
        { homePage: true, text: this.$t("breadcrumb.home"), to: "/" },
        { text: this.$t("breadcrumb.ecosystem"), to: "/ecosystem" },
        {
          text: this.$t(`breadcrumb.network.mentor`),
          to: `/ecosystem/discover/category/mentor`,
        },
        { text: this.profileInfo.name, disable: true },
      ];
      return crumbs;
    },
    category() {
      return this.$route.params.networkCategory || "";
    },
    categoryName() {
      return this.category.split("-").join(" ");
    },
    mentorId() {
      return this.$route.params.mentorId;
    },
    isMyMentorProfile() {
      return this.profileInfo?.owner?.id == this.currentUser?.id;
    },

    hasOwner() {
      return !!this.profileInfo?.owner;
    },

    socialMediaIcon() {
      var icon = "";
      const socialUrl = this.profileInfo.social_media_url || "";
      if (socialUrl.includes("facebook")) {
        icon = "facebook";
      } else if (socialUrl.includes("linkedin")) {
        icon = "linkedin";
      } else {
        icon = "link";
      }
      return icon;
    },
    mentorInfo() {
      const _pf = this.profileInfo;
      return [
        { text: this.$t("general_info") },
        {
          children: [
            {
              text: this.$t("bio"),
              value: _pf.bio,
            },
            { text: this.$t("company"), value: _pf.company },
            { text: this.$t("industry"), value: _pf.industry?.name },
            { text: this.$t("role"), value: _pf.role },
          ],
        },
        { text: this.$t("entrepreneurship") },
        {
          children: [
            {
              text: this.$t("investor"),
              value: _pf.investor ? this.$t("yes") : this.$t("no"),
            },
            {
              text: this.$t("previous_entrepreneur"),
              value: _pf.previous_entrepreneur ? this.$t("yes") : this.$t("no"),
            },
            {
              text: this.$t("previous_startup"),
              value: _pf.previous_startup ? this.$t("yes") : this.$t("no"),
            },
            { text: this.$t("interest"), value: _pf.interest },
          ],
        },
        // { text: this.$t("expertise") },
        // {
        //   children: [
        //     {
        //       text: this.$t("expertise"),
        //       value: Array.isArray(_pf.expertise)
        //         ? _pf.expertise
        //             .map((item) => item.name)
        //             .join(", ")
        //             .replaceAll("_", " ")
        //         : this.$t("n_a"),
        //       isChip: true,
        //       hideTitle: true,
        //     },
        //   ],
        // },
      ];
    },

    connectionStatus() {
      return this.profileInfo?.connection_request_status;
    },
    startupMembers() {
      return this.profileInfo?.team || [];
    },

    userName() {
      const { first_name, first_name_kh, last_name, last_name_kh } =
        this.profileInfo || {};
      return this.$isKm()
        ? [first_name_kh, last_name_kh].join(" ")
        : [first_name, last_name].join(" ");
    },
  },
  watch: {
    mentorId: {
      handler(v) {
        if (!!v) {
          this.getDetail();
          return;
        }
        this.$router.replace(`/ecosystem/discover/category/mentor`);
      },
    },
  },
  async fetch() {
    await this.getDetail();
  },
  methods: {
    ...mapActions("stakeholder", ["getStakeHolderDetail"]),
    ...mapActions("app", ["setAuthDialogVisibility"]),
    ...mapActions("connection", { requestConnection: "create" }),
    _showReportForm() {
      this.$refs.formReport.openForm(this.profileInfo.id, "mentor");
    },
    getDetail() {
      const { mentorId: id } = this;

      return this.getStakeHolderDetail({ id, category: "mentor" })
        .then((data) => {
          this.profileInfo = Object.assign({}, data);
          this.expertises = Object.assign([], data.expertise);
        })
        .catch((e) => {
          this.notFound = true;
        });
    },
    makeConnection() {
      const isLogin = !!this.$cookiz.get("access_token");
      this.makingConnection = true;
      if (!isLogin) {
        this.setAuthDialogVisibility(true);
        this.makingConnection = false;
        return;
      }
      const payload = { user: this.profileInfo.owner?.id };

      this.requestConnection({ payload })
        .then((res) => {
          this.makingConnection = false;
          this.getDetail();

          this.$swal.fire(
            `${this.$t("get_listed.dialog.title.success")}!`,
            "",
            "success"
          );
        })
        .catch((error) => {
          this.makingConnection = false;
          const message = error.response.data.message || error;
          this.$swal.fire(
            `${this.$t("get_listed.dialog.title.fail")}!`,
            message,
            "error"
          );
        });
    },
    closeDialog(v) {
      this.setAuthDialogVisibility(false);
    },
  },
};
